"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developmentSubappLoader = void 0;
// types
const mobileConnector_1 = require("../../mobileConnector");
const initializer_1 = require("../../initializer");
const subappDevelopmentBaseLoader_1 = require("../subappDevelopmentBaseLoader");
/**
 * Wraps the app in the providers and mounts it directly into the DOM
 */
const developmentSubappLoader = async (params) => {
    if (await (0, mobileConnector_1.initMobileCommunicator)(initializer_1.Session, params.mobileConnectorConfig)) {
        await initializer_1.HybridAuthenticator.login();
    }
    await (0, subappDevelopmentBaseLoader_1.developmentSubappBaseFeatureLoader)(params);
    (0, subappDevelopmentBaseLoader_1.developmentSubappBaseRender)(params);
};
exports.developmentSubappLoader = developmentSubappLoader;
//# sourceMappingURL=index.js.map